import { Trans, useTranslation } from "react-i18next";

/**
 * Marketing headline shown on the left half of the auth screen
 * (desktop only). The screen itself is always dark, so the copy
 * renders white regardless of the app theme.
 */
const AuthHero = () => {
  const { t } = useTranslation();

  return (
    <div className="hidden max-w-xl lg:block">
      <h1 className="text-[40px] leading-[1.08] tracking-tight xl:text-[52px]">
        <Trans
          i18nKey="auth.hero.title"
          components={{ accent: <span className="text-primary-80" /> }}
        />
      </h1>
      <p className="mt-6 max-w-md text-lg leading-relaxed text-grey-60 dark:text-grey-70">
        {t("auth.hero.subtitle")}
      </p>
    </div>
  );
};

export default AuthHero;
